import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import axios from 'axios'
import React, { useEffect, useState } from 'react'

function PDetails() {

    const [vorname, setVorname] = useState('')
    const [lastname, setLastname] = useState('')
    const [anschrift, setAnschrift] = useState('')
    const [plz, setPlz] = useState('')
    const [stadt, setStadt] = useState('')
    const [msg, setMsg] = useState()

    useEffect(() => {
        axios.get("https://dealersonly.parts/beta/api/user/private")
        .then(res => {
          setAnschrift(res.data.shippingadress.street)
          setVorname(res.data.first_name)
          setLastname(res.data.last_name)
          setPlz(res.data.shippingadress.plz)
          setStadt(res.data.shippingadress.ort)
        })
        .catch((error) => {
          console.log(error);
        })

    
    }, [])

    const Submit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`https://dealersonly.parts/beta/api/edit/private`, {
                vorname: vorname,
                lastname: lastname,
                anschrift: anschrift,
                plz: plz,
                stadt: stadt
            });
            
        } catch (error) {
            if (error.response) {
                setMsg(error.response.data.msg);
            }
        }
    }


  return (
    <div className="space-y-6 sm:px-6 lg:col-span-9 lg:px-0">
              <section aria-labelledby="payment-details-heading">
                {msg && <p>{msg}</p>}
                <form onSubmit={Submit}>
                  <div className="shadow sm:overflow-hidden sm:rounded-md">
                    <div className="bg-white py-6 px-4 sm:p-6">
                      <div>
                        <h2 id="payment-details-heading" className="text-lg font-medium leading-6 text-gray-900">
                          Persönliche Angaben
                        </h2>
                        <p className="mt-1 text-sm text-gray-500">
                          Aktualisieren Sie Ihre Daten, die für die Abrechnung verwendet werden. 
                        </p>
                      </div>

                      <div className="mt-6 grid grid-cols-4 gap-6">


                        <div className="col-span-4 sm:col-span-2">
                          <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                            Vorname
                          </label>
                          <input
                          value={vorname}
                          onChange={e=>setVorname(e.target.value)}
                            type="text"
                            name="first-name"
                            id="first-name"
                            autoComplete="cc-given-name"
                            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                            required
                          />
                        </div>

                        <div className="col-span-4 sm:col-span-2">
                          <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                            Nachname
                          </label>
                          <input
                          value={lastname}
                          onChange={e=>setLastname(e.target.value)}
                            type="text"
                            name="last-name"
                            id="last-name"
                            autoComplete="cc-family-name"
                            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                            required
                          />
                        </div>

                        <div className="col-span-4 sm:col-span-2">
                          <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
                            Anschrift und Hausnummer
                          </label>
                          <input
                          value={anschrift}
                          onChange={e=>setAnschrift(e.target.value)}
                            type="text"
                            name="business-address"
                            id="business-address"
                            autoComplete="adress"
                            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                            required
                          />
                        </div>

                        <div className="col-span-4 sm:col-span-1">
                          <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">
                            Postleitzahl
                          </label>
                          <input
                          value={plz}
                          onChange={e=>setPlz(e.target.value)}
                            type="text"
                            name="postal-code"
                            id="postal-code"
                            autoComplete="postal-code"
                            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                            required
                          />
                        </div>

                        <div className="col-span-4 sm:col-span-1">
                          <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">
                            Stadt
                          </label>
                          <input
                          value={stadt}
                          onChange={e=>setStadt(e.target.value)}
                            type="text"
                            name="postal-code"
                            id="postal-code"
                            autoComplete="postal-code"
                            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                            required
                          />
                        </div>

                        
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
                      >
                        Speichern
                      </button>
                    </div>
                  </div>
                </form>
              </section>
              </div>
  )
}

export default PDetails